"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getURLPath = getURLPath;

function getURLPath() {
  if (window && window.location) {
    return window.location.pathname;
  }
}